import React, { useEffect, useState } from 'react'
import { CriteriaModal } from '../../TaskBluePrints/HelperComponents/CriteriaModal';
import AwsServerService from '../../../common/util/AwsServerService';
import { getProjectFieldMeta } from '../Util';
import { useSelector } from 'react-redux';

export default function GetCriteriaModal({setCriteriaModal,criteriaModal, view, onSelectedData, selectedData, allPipelineData}) {
const [criteriaFieldGroups, setCriteriaFieldGroups] = useState({}); 
let allDealsAndUsers = useSelector((state) => state.AppReduxContext.AllDeals);
useEffect(()=>{
getCriteriaFields()
},[])
const getCriteriaFields = async () => {
    await AwsServerService.getCriteriaFields().then(res => {
      let obj = {};
      if (res?.data) {
        res.data.forEach(one => {
          if (obj[one.module]) {
            obj[one.module] = [...obj[one.module], one];
          } else {
            obj[one.module] = [one];
          }
        })
      }
      obj.Task.push(
        {
          "ROWID": 18,
          "label": "Priority",
          "field": "Priority",
          "type": "TEXT",
          "module": "Task",
          "apikey": ""
        },
        {
          "ROWID": 19,
          "label": "Task Status",
          "field": "TaskStatus",
          "type": "MULTI-PICKLIST",
          "module": "Task",
          "apikey": ""
        },
        {
          "ROWID": 20,
          "label": "Pipeline",
          "field": "PipelineName",
          "type": "MULTI-PICKLIST",
          "module": "Task",
          "apikey": ""
        },
        {
          "ROWID": 21,
          "label": "Task Flow",
          "field": "TaskFlowObject",
          "type": "MULTI-PICKLIST",
          "module": "Task",
          "apikey": ""
        },
      )
      let DataObject = getProjectFieldMeta(allDealsAndUsers || {})
      console.log("DataObject", DataObject);
      obj.Project = [...obj.Project, ...DataObject]
      setCriteriaFieldGroups(obj);
    })
  }
  return (
    <CriteriaModal
            mainFields={criteriaFieldGroups}
            open={criteriaModal}
            criteriaRows={selectedData}
            action={view}
            setOpen={setCriteriaModal}
            onSave={(data) => {
               
              let obj = { ...selectedData };
              const filteredData = data?.filter(item => item?.initial !== undefined);
              // obj["data"]["Criteria"] = data;
              onSelectedData(data);
    
            }}
            FromTask={true}
            allPipelineData = {allPipelineData}
          />
  )
}
